/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unranked_Reason_Open_RoundsInputs */



/**
* | output |
* | --- |
* | "open rounds" |
*
* @param {Tournament_Unranked_Reason_Open_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unranked_reason_open_rounds = /** @type {((inputs?: Tournament_Unranked_Reason_Open_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unranked_Reason_Open_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("rondes ouvertes")
	if (locale === "es") return /** @type {LocalizedString} */ ("rondas abiertas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("rodadas abertas")
	if (locale === "it") return /** @type {LocalizedString} */ ("round aperti")
	return /** @type {LocalizedString} */ ("open rounds")
});